import { PaletteOptions } from "@mui/material/styles";
import { colors } from "../globalColors";

// Palette Colors (all customized) -----------------------------
export const palette: PaletteOptions = {
  primary: {
    main: "#0E9E57", // success main
    dark: "#0A703E", // success dark
    light: "#12CE72", // success light
    contrastText: colors.white,
  },
  secondary: {
    main: colors.grey800, // grey 800
    dark: colors.grey900, // grey 900
    light: colors.grey400, // grey 400
    contrastText: colors.white,
  },
  success: {
    main: "#0E9E57",
    dark: "#0A703E",
    light: "#12CE72",
    contrastText: colors.white,
  },
  info: {
    main: "#2E88C5",
    dark: "#256C9D",
    light: "#A4CEEA",
    contrastText: colors.white,
  },
  error: {
    main: "#E03730",
    dark: "#BF231D",
    light: "#ED8B87",
    contrastText: colors.white,
  },
  grey: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD", // secondary light
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242", // secondary main
    900: "#212121", // secondary dark
    A100: "#D5D5D5",
    A200: "#AAAAAA",
    A400: "#616161",
    A700: "#303030",
  },
  text: {
    primary: "rgba(33,33,33,1.0)",
    secondary: "rgba(117,117,117,1.0)",
    disabled: "rgba(189,189,189,1.0)",
    // hint: 'rgba(158,158,158,1.0)'
  },
  action: {
    active: "rgba(0,0,0,0.54)",
    hover: "rgba(0,0,0,0.04)",
    selected: "rgba(0,0,0,0.08)",
    disabled: "rgba(0,0,0,0.26)",
    disabledBackground: "rgba(0,0,0,0.12)",
    focus: "rgba(0,0,0,0.12)",
  },
  common: {
    black: colors.black,
    white: colors.white,
  },
  background: {
    paper: colors.white,
    default: "#F5F5F5", // grey 50
  },
  divider: "rgba(0,0,0,0.12)",
};
